import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ResourcesService } from '../../data/resources.service';
import { PlantsService } from 'src/app/features/company/data/plants.service';
import { CRUDAction } from 'src/app/components/JBM/Views/JBMCRUDTitle/JBMCRUDTitle.component';
import { JBMCheckGroupItem } from 'src/app/components/JBM/Forms/JBMFormGroups/JBMCheckGroup/JBMCheckGroup.component';
import { JBMSelectOption } from 'src/app/components/JBM/Forms/JBMFormGroups/JBMSelect/JBMSelect.component';

@Component({
   selector: 'resource-form',
   templateUrl: './resource-form.component.html',
   styleUrls: ['./resource-form.component.scss']
})
export class ResourceFormComponent implements AfterViewInit, OnInit {
   action: CRUDAction;
   form: FormGroup;
   submitted: boolean = false;
   resource: any = null
   plants: any[] = []
   linkedPlants: any = { managementApp: [], recipesApp: [] }
   typeOptions: JBMSelectOption[]=[]       
   plantItems: JBMCheckGroupItem[] = []

   @Input() id: number = 0
   @Input() types: any[]=[];

   @Output() onSave = new EventEmitter();
   @Output() onCancel = new EventEmitter();

   constructor(
      private ResourcesService: ResourcesService,
      private PlantsService: PlantsService,
      private formBuilder: FormBuilder,
   ) {
      this.addControls();
   }
   ngOnInit(): void {
      this.action = this.id ? CRUDAction.Update : CRUDAction.Create;

      if (!this.id) {
         this.resource = { code: '', type: 0, description: '', plantIds: [] }
         this.getPlants()
         return
      }

      this.ResourcesService.getOne(this.id).subscribe(
         (data: any) => this.resource = data.data,
         (error: any) => console.error(error),
         () => {
            this.ResourcesService.getLinkedPlants(this.id).subscribe(
               (data: any) => this.linkedPlants = data.data,
               (error: any) => console.error(error),
               () => this.getPlants() 
            )
         }
      );
   }
   ngAfterViewInit(): void {
      for(let type of this.types) 
         this.typeOptions.push({ key: type.id.toString(), value: type.description })

      let element = document.getElementById('code')
      if (element) element.focus();
   }
   getPlants() {
      this.PlantsService.getData().subscribe(
         (data: any) => {
            this.plants = data.data
            this.setControlValues()
            this.setPlantItems()
         }, (error: any) => console.error(error)
      )
   }

   addControls() {
      this.form = this.formBuilder.group({
         code: new FormControl('', [Validators.required]),
         description: new FormControl('', [Validators.required]),
         type:  new FormControl('', [Validators.required]),
         plantIds: new FormControl([], [Validators.required, Validators.minLength(1)])
      }, { updateOn: "blur" });
   }
   setControlValues() {
      this.form.controls.code.setValue(this.resource.code);
      this.form.controls.description.setValue(this.resource.description);
      this.form.controls.type.setValue(this.resource.type);

      // Set plants selection
      let plantsIds=[]
      if(this.id) 
         for( let linkedPlant of this.linkedPlants.managementApp)
            plantsIds.push(linkedPlant.plantId)               
      else   
         for( let plant of this.plants)
            plantsIds.push(plant.id)               
      this.formControls['plantIds'].setValue(plantsIds)
   }

   get formControls() { return this.form.controls; }

   setPlantItems() {
      let plantIds = this.formControls['plantIds'].value
      for (let plant of this.plants) {
         let checked = plantIds.indexOf(plant.id) > -1
         this.plantItems.push({
            id: plant.id,
            text: plant.name,
            checked: checked,
            disabled: !this.allowUnlink(plant.id)
         })
      }
   }
   allowUnlink(plantId: number): boolean {
      const links = [...this.linkedPlants.managementApp, ...this.linkedPlants.recipesApp];

      // Not allowed to unlink when not allowed in one the apps for this plant
      for (const link of links) 
         if (link.plantId === plantId && !link.allowUnlink) 
            return false;

      return true;
   }   
   occursInApp(plantId: number) {
      return this.linkedPlants.managementApp.some((app: any) => app.plantId === plantId ) ||
         this.linkedPlants.recipesApp.some((app: any) => app.plantId === plantId )
   }
   itemsChange(ids: number[]) {
      this.formControls['plantIds'].setValue(ids)
   }
   save() {
      this.submitted = true;
      if (this.form.invalid)
         return;

      this.resource={ 
         id: this.id || 0, 
         type: parseInt(this.formControls['type'].value), 
         code: this.formControls['code'].value, 
         description: this.formControls['description'].value,
         plantIds: this.formControls['plantIds'].value
      }

      if(!this.id)
         this.ResourcesService.create(this.resource).subscribe(
           () => this.onSave.emit(), (error: any) => this.handleError(error))
      else
         this.ResourcesService.update(this.resource).subscribe(
           () => this.onSave.emit(), (error: any) => this.handleError(error))
   }
   handleError(error: string) {
      switch(error) {
         case 'code_not_unique':
            this.formControls.code.setErrors({'code_not_unique': true});
            break;
         case 'description_not_unique':
            this.formControls.description.setErrors({'description_not_unique': true});
            break;
      }
   }
   cancel() {
      this.onCancel.emit();
   }
}
